import { TARGET } from "../constants/target.qwik.mjs";
import { omit } from "../helpers/omit.qwik.mjs";
import { evaluate } from "./evaluate/evaluate.qwik.mjs";
import { resolveLocalizedValues } from "./extract-localized-values.qwik.mjs";
import { fastClone } from "./fast-clone.qwik.mjs";
import { set } from "./set.qwik.mjs";
import { transformBlock } from "./transform-block.qwik.mjs";
function deepCloneWithConditions(obj) {
  if (obj === null || typeof obj !== "object")
    return obj;
  if (Array.isArray(obj))
    return obj.map((item) => deepCloneWithConditions(item));
  if (obj["@type"] === "@builder.io/sdk:Element")
    return obj;
  const clonedObj = {};
  for (const key in obj)
    if (key !== "meta" && Object.prototype.hasOwnProperty.call(obj, key))
      clonedObj[key] = deepCloneWithConditions(obj[key]);
  return clonedObj;
}
const IS_SDK_WITHOUT_CACHED_PROCESSED_BLOCK = [
  "svelte",
  "vue",
  "angular",
  "qwik",
  "solid"
].includes(TARGET);
const getCopy = (block) => {
  if (IS_SDK_WITHOUT_CACHED_PROCESSED_BLOCK) {
    const copy = fastClone(block);
    const copied = {
      ...copy,
      properties: {
        ...copy.properties
      },
      actions: {
        ...copy.actions
      }
    };
    return copied;
  } else {
    const copy = deepCloneWithConditions(omit(block, "children", "meta"));
    return {
      ...copy,
      properties: {
        ...copy.properties
      },
      actions: {
        ...copy.actions
      },
      children: block.children,
      meta: block.meta
    };
  }
};
const evaluateBindings = ({ block, context, localState, rootState, rootSetState }) => {
  if (!block.bindings)
    return block;
  const copied = getCopy(block);
  for (const binding in block.bindings) {
    const expression = block.bindings[binding];
    const value = evaluate({
      code: expression,
      localState,
      rootState,
      rootSetState,
      context
    });
    set(copied, binding, value);
  }
  return copied;
};
function getProcessedBlock({ block, context, localState, rootState, rootSetState }) {
  let transformedBlock = transformBlock(block);
  transformedBlock = evaluateBindings({
    block: transformedBlock,
    localState,
    rootState,
    rootSetState,
    context
  });
  transformedBlock = resolveLocalizedValues(transformedBlock, rootState.locale);
  return transformedBlock;
}
export {
  deepCloneWithConditions,
  getProcessedBlock
};
